import { convert, convertFromDays } from '@/utils/conversions'
import displayFormats from '@/mixins/displayFormats'

export const ranges =
{
  newborn: {
    unit: 'days',
    min: 0,
    max: 59,
    total: 60
  },
  child: {
    unit: 'months',
    min: 2,
    max: 59,
    total: 58
  },
  youth: {
    unit: 'years',
    min: 5,
    max: 14,
    total: 10
  },
  adult: {
    unit: 'years',
    min: 15,
    max: 100,
    total: 86
  }
}

export default {
  mixins: [displayFormats],
  methods: {
    ageTypeByDays(daysOld) {
      if (daysOld <= ranges.newborn.max) {
        return 'newborn'
      } else if (daysOld <= convert(ranges.child.unit, 'days', ranges.child.max, 0)) {
        return 'child'
      } else if (daysOld <= convert(ranges.youth.unit, 'days', ranges.youth.max, 0)) {
        return 'youth'
      } else {
        return 'adult'
      }
    },
    ageDisplayString(value) {
      let retString = ''
      if (value < 61) {
        const daysValue = this.$i18n.n(Math.round(value), 'decimal')
        retString = this.days(daysValue)
      }
      else if (value < 365) {
        const monthsValue = this.$i18n.n(convertFromDays('months', 0, value), 'decimal')
        return `${monthsValue} ${this.$t('partials.time.months')}`
      }
      else if (value < 1825) {
        const monthsValue = this.$i18n.n(convertFromDays('months', 0, value), 'decimal')
        return `${monthsValue} ${this.$t('partials.time.months')} (${this.monthsAndYears(monthsValue)})`
      }
      else {
        const yearsValue = this.$i18n.n(convertFromDays('years', 0, value), 'decimal')
        retString = `${yearsValue} ${this.$t('partials.time.years')}`
      }
      return retString
    },
    getAgeRanges() {
      return ranges;
    }
  }
}
